import { render, staticRenderFns } from "./test-record.vue?vue&type=template&id=50340725&"
import script from "./test-record.vue?vue&type=script&lang=js&"
export * from "./test-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50340725')) {
      api.createRecord('50340725', component.options)
    } else {
      api.reload('50340725', component.options)
    }
    module.hot.accept("./test-record.vue?vue&type=template&id=50340725&", function () {
      api.rerender('50340725', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/test-record/test-record.vue"
export default component.exports